import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { DataSourceResponse, PatientConditionState } from '../../models';
import { Observable } from 'rxjs';
import { HttpParamsEncoder } from '../../tools';


@Injectable({
    providedIn: 'root',
})
export class PatientConditionStateService extends ApiService {
  endPoint = 'api/patientConditionStates';

    get(id: string) {
        return this.http.get(`${this.clinicsBaseURL}/${this.endPoint}/${id}`);
    }

    getList(queryParams?: any): Observable<DataSourceResponse<any>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.clinicsBaseURL}/${this.endPoint}`, { params });
    }

    create(model: PatientConditionState) {
        return this.http.post(`${this.clinicsBaseURL}/${this.endPoint}`, model);
    }

    update(id: string, model: PatientConditionState) {
        return this.http.put(`${this.clinicsBaseURL}/${this.endPoint}/${id}`, model);
    }

    delete(id: string) {
      return this.http.delete(`${this.clinicsBaseURL}/${this.endPoint}/${id}`);
    }
}
